// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}
/* Apply to all elements */
* {
  scrollbar-width: thin; /* For Firefox */
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent; /* For Firefox */
}

/* Make the scrollbar thin and subtle for Webkit browsers */
*::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

/* Handle */
*::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

/* Handle on hover */
*::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.5);
}

/* Hide the scrollbar by default */
*::-webkit-scrollbar-thumb {
  background-color: transparent;
}

/* Display the scrollbar on hover */
*:hover::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;AACA,0BAA0B;AAC1B;EACE,qBAAqB,EAAE,gBAAgB;EACvC,+CAA+C,EAAE,gBAAgB;AACnE;;AAEA,2DAA2D;AAC3D;EACE,UAAU;EACV,WAAW;AACb;;AAEA,WAAW;AACX;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,8BAA8B;AAChC;;AAEA,kCAAkC;AAClC;EACE,6BAA6B;AAC/B;;AAEA,mCAAmC;AACnC;EACE,oCAAoC;AACtC","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n/* Apply to all elements */\n* {\n  scrollbar-width: thin; /* For Firefox */\n  scrollbar-color: rgba(0, 0, 0, 0.2) transparent; /* For Firefox */\n}\n\n/* Make the scrollbar thin and subtle for Webkit browsers */\n*::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n/* Handle */\n*::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 3px;\n}\n\n/* Handle on hover */\n*::-webkit-scrollbar-thumb:hover {\n  background: rgba(0, 0, 0, 0.5);\n}\n\n/* Hide the scrollbar by default */\n*::-webkit-scrollbar-thumb {\n  background-color: transparent;\n}\n\n/* Display the scrollbar on hover */\n*:hover::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
